module.exports = __webpack_public_path__ + "static/img/Frame_4108@2x.3a45980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/Frame_4108@2x.png
// module id = vMxr
// module chunks = 64